// extracted by mini-css-extract-plugin
export default {"button":"topic-status-with-button_button__XfugL"};